import { useEffect, useState } from 'react';
import { CenterLoader } from 'connected-components/Loader/Loader';
import EmptyData from 'components/EmptyData';
import moment from 'moment';
import * as ZendeskService from 'common/services/zendesk.service';
import { Link } from '@material-ui/core';
import Text from 'components/base/Text';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { LOCAL_STORAGE_KEYS } from 'common/constants/constants';

const Processing = ({ repositories = [], getRepositories }) => {
  const [isHardStop, setIsHardStop] = useState(false);
  const [getReposPoolingInterval, setGetReposPoolingInterval] = useState(null);
  const HARD_STOP_LIMIT_MS = 120 * 1000;
  const POLLING_REPOS_AFTER_MS = 20 * 1000;

  useEffect(() => {
    getRepositories();
  }, []);

  useEffect(() => {
    const userSavedReposTimeStamp = BrowserStorageAccessor().local.get(
      LOCAL_STORAGE_KEYS.USER_SAVED_REPOS_TS
    );
    if (Array.isArray(repositories) && repositories.length) {
      clearInterval(getReposPoolingInterval);
      return;
    }

    if (!getReposPoolingInterval) {
      setGetReposPoolingInterval(
        setInterval(
          () => getRepositories(),
          POLLING_REPOS_AFTER_MS
        )
      );
    }

    if (
      moment().diff(userSavedReposTimeStamp) > HARD_STOP_LIMIT_MS &&
      !repositories.length
    ) {
      clearInterval(getReposPoolingInterval);
      setIsHardStop(true);
      window.TrackJS &&
        window.TrackJS.console.error(
          'failed to get repositories after 2 minuts of waiting, check if RepositoriesCollector job faild to save to db'
        );
    }
  }, [repositories]);

  return isHardStop ? (
    <EmptyData
      margin='auto'
      title='Oops, something went wrong'
      info={
        <Text size='medium' color='shuttleGray'>
          Please{' '}
          <Link onClick={ZendeskService.openSupportRequest}>
            contact support
          </Link>
        </Text>
      }
    />
  ) : (
    <CenterLoader />
  );
};

export default Processing;
